





















































































































































































import { Vue, Component } from "vue-property-decorator";
import Api from "@/Api";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "framework7/css/framework7.bundle.min.css";
import Framework7 from "framework7";
import _ from "lodash";

@Component({
  components: {
    vueDropzone: vue2Dropzone,
  },
})
export default class Aufgabe extends Vue {
  aufgabe: any = {};
  device = Framework7.device;
  dzAktiv = false;
  edit = false;
  sheetOpened = false;
  kommentar = "";
  url = "";
  schueler: boolean | number = false;
  dropzoneOptions = {
    url:
      "https://hausaufgaben.suetti.it/api/aufgaben/" +
      (this.$f7route as any).params.id,
    thumbnailWidth: 120,
    timeout: 90000,
    // thumbnailHeight: 120,
    // resizeWidth: 1200,
    // resizeMimeType: "image/jpeg",
    maxFilesize: 30,
    maxThumbnailFilesize: 30,
    // forceFallback: true,
    // uploadMultiple: true,
    // capture: "camera",
    previewsContainer: "#dzpreview",
    headers: {
      "X-DEV": "suetti.it",
      "X-CODE": localStorage.getItem("code"),
    },
  };

  mounted() {
    this.laden();
    (this.$f7 as any).on("logout", () => this.laden);
  }

  laden(event?: CustomEvent) {
    this.kommentar = "";
    this.sheetOpened = false;
    const params = (this.$f7route as any).params;
    this.url = "/aufgaben/" + params.id;
    if (params.schueler) {
      this.schueler = params.schueler;
      this.url += "/" + params.schueler;
      (this.$refs.myVueDropzone as any).setOption(
        "url",
        "https://hausaufgaben.suetti.it/api/aufgaben/" +
          params.id +
          "?schueler=" +
          params.schueler
      );
    }

    Api.get(this.url).then((r) => {
      this.edit = false;
      this.aufgabe = r.data;
      this.kommentar = this.aufgabe.kommentar;
      if (event) event.detail();
    });
  }

  bildEntfernen(bild) {
    Api.delete(
      "/aufgaben/" + (this.$f7route as any).params.id + "/bilder/" + bild.name
    ).then(() => {
      this.aufgabe.bilder = _.reject(this.aufgabe.bilder, { name: bild.name });
      if (!this.aufgabe.bilder.length) {
        this.edit = false;
      }
      //this.laden()
    });
  }

  dzFileAdd() {
    setTimeout(() => {
      (this.$f7 as any).preloader.hide();
    }, 1000);

    this.dzAktiv = true;
  }

  dzFileError(err) {
    (this.$f7 as any).preloader.hide();
    this._toast("Fehler, Bild kann nicht verarbeitet werden.", "error");
    console.log("FEHLER", err);
  }

  fileAdded() {
    (this.$f7 as any).preloader.show();
  }

  dzComplete() {
    if (!(this.$refs.myVueDropzone as any).getUploadingFiles().length) {
      setTimeout(() => {
        this.dzAktiv = false;
        (this.$refs.myVueDropzone as any).removeAllFiles();
        this._toast("Aufgaben wurden hochgeladen");
        this.laden();
      }, 1000);
    }
  }

  pclick() {
    const evt = document.createEvent("MouseEvents");
    evt.initEvent("click", true, false);
    (this.$refs.myVueDropzone as any).dropzone.element.dispatchEvent(evt);
  }

  photoBrowser(id: number, typ: string) {
    if (typ == "bilder") {
      (this.$refs.bilder as any).open(id);
    } else {
      (this.$refs.lehrerbilder as any).open(id);
    }
  }

  taphold() {
    this._toast("TapHold OK");
  }

  kommentieren() {
    if (!this.kommentar.length) return;

    Api.put("/aufgaben/" + this.aufgabe.sid + "/kommentar", {
      aufgabe: this.aufgabe.id,
      kommentar: this.kommentar,
    }).then((r) => {
      this._toast("Kommentar wurde gespeichert");
      this.laden();
    });
  }

  _toast(text: string, typ?: string) {
    typ = typ || "success";
    (this.$f7 as any).toast
      .create({
        text: text,
        position: "top",
        closeTimeout: 3000,
        cssClass: typ,
      })
      .open();
  }
}
